import { SidebarMenuItem } from "./SidebarMenuItem";

import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";
import { useAuth } from '../../../../../app/modules/auth/core/Auth'
import { permissions } from '../../../../../app/modules/apps/setting/role/table/columns/_columns'

export const SidebarMenuAccountant = () => {
  const { can } = useAuth()
  const accountantPerms = permissions
    .filter(({ section }) => section === 'accounting_general')
    .map(({ value }) => value)

  if (!can(accountantPerms)) return null

  return (
    <>
    <SidebarMenuItemWithSub
        to='/accountant'
        icon='wallet'
        title='การบัญชี'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/accountant/chart-of-accounts' icon='document' fontIcon='bi-app-indicator' title={'ผังบัญชี'} />
        <SidebarMenuItem to='/accountant/daily-journal' icon='document' fontIcon='bi-app-indicator' title={'บัญชีรายวัน'} />
        <SidebarMenuItem to='/accountant/general-ledger' icon='document' fontIcon='bi-app-indicator' title={'บัญชีแยกประเภท'} />
        <SidebarMenuItem to='/accountant/trial-balance' icon='document' fontIcon='bi-app-indicator' title={'งบทดลอง'} />
        <SidebarMenuItem to='/accountant/balance-sheet' icon='document' fontIcon='bi-app-indicator' title={'งบฐานะการเงิน'} />
        <SidebarMenuItem to='/accountant/income-statement' icon='document' fontIcon='bi-app-indicator' title={'งบกำไรขาดทุน'} />
        <SidebarMenuItem to='/accountant/cash-flow' icon='document' fontIcon='bi-app-indicator' title={'งบกระแสเงินสด'} />
        <SidebarMenuItem to='/accountant/equity-changes' icon='document' fontIcon='bi-app-indicator' title={'งบการเปลี่ยนแปลงผู้ถือหุ้น'} />
        <SidebarMenuItem to='/accountant/accountant-report' icon='chart-simple' fontIcon='bi-app-indicator' title={'รายงานทางบัญชี'} />
        <SidebarMenuItem to='/accountant/dbd-efiling' icon='document' fontIcon='bi-app-indicator' title={'DBD e-Filling'} />
      </SidebarMenuItemWithSub>
    </>
  )
}
